import { Builder } from '@builder.io/react';
import EmbedMedia, { services } from './embedMedia';

Builder.registerComponent(EmbedMedia, {
  name: 'Embed Media',
  static: true,
  inputs: [
    {
      name: 'service',
      type: 'string',
      enum: services,
      required: true,
      defaultValue: services[0],
    },
    {
      name: 'url',
      type: 'string',
      required: true,
      defaultValue: 'https://www.example.com',
    },
  ],
});
